<template lang="">
  <div>
    <small class="text-black-50 font-weight-lighter">Choose a child</small>
    <div class="my-2">
      <b-form-select
        class="w-full flex-grow-1 flex-sm-grow-0"
        size="sm"
        required
        v-model="childrensSelected"
        :options="childrens"
      >
      </b-form-select>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    childrens: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      childrensSelected: [],
    };
  },
  watch: {
    childrensSelected(newValue) {
      this.$emit('update:childrensIdsSelected', newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper-childrens {
  display: grid;
  margin-bottom: 1rem;
  &-box {
    display: flex;
    justify-content: space-between;
    padding: 5px 8px;
    border: solid 1px #ccc;
    border-radius: 5px;
  }
}
</style>
